import { render, staticRenderFns } from "./CorrespondenceEmailUpdate.vue?vue&type=template&id=52c4c218&scoped=true"
import script from "./CorrespondenceEmailUpdate.vue?vue&type=script&lang=js"
export * from "./CorrespondenceEmailUpdate.vue?vue&type=script&lang=js"
import style0 from "./CorrespondenceEmailUpdate.vue?vue&type=style&index=0&id=52c4c218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c4c218",
  null
  
)

export default component.exports